// รายการหน้าสมาชิก: ชื่อ -> URL (ตรงกับ Starbet999), ต้อง login ไหม, key คำแปล
export const PANELS = {
  deposit: { path: '/deposit', auth: true, label: 'deposit' },
  withdraw: { path: '/withdraw', auth: true, label: 'withdraw' },
  affiliate: { path: '/refer/overview', auth: true, label: 'affiliate' },
  checkin: { path: '/checkindaily', auth: false, label: 'check_in' },
  wheel: { path: '/luckyfortune', auth: false, label: 'lucky_fortune' },
  cardgame: { path: '/cardminigame', auth: false, label: 'mh_card_game' },
  promotion: { path: '/promotion', auth: false, label: 'promotion' },
  cashback: { path: '/loss', auth: true, label: 'cashback' },
  rebate: { path: '/rebate', auth: true, label: 'rebate' },
  toprank: { path: '/toprank', auth: false, label: 'toprank' },
  redeem: { path: '/redeemreward', auth: true, label: 'redeem_reward' },
  statement: { path: '/statement', auth: true, label: 'history' },
  profile: { path: '/profile', auth: true, label: 'profile' },
};

export function panelFromPath(pathname) {
  const p = '/' + String(pathname || '').replace(/^\/+|\/+$/g, '');
  if (p === '/deposit2') return 'deposit';
  if (p.startsWith('/refer')) return 'affiliate';
  return Object.keys(PANELS).find((k) => PANELS[k].path === p) || null;
}

